import isAppRunningInIframe from './isAppRunningInIframe'

export const getURLTarget = () => {
    return isAppRunningInIframe() ? '_self' : '_blank'
}

export default getURLTarget
